/* eslint-disable camelcase */

export enum OrderState {
    INITIAL = 'INITIAL',
    IN_PROGRESS = 'IN_PROGRESS',
    SHIPPED = 'SHIPPED',
    CANCELED = 'CANCELED',
    RETURNED = 'RETURNED',
}

export enum OrderCancelationState {
    PARTIAL_CANCELLED = 'PARTIAL_CANCELLED',
    FULL_CANCELLED = 'FULL_CANCELLED',
    PARTIAL_IN_PROGRESS = 'PARTIAL_IN_PROGRESS',
    FULL_FAILED = 'FULL_FAILED',
    PARTIAL_FAILED = 'PARTIAL_FAILED',
    NONE_CANCELED = 'NONE_CANCELED',
    FULL_IN_PROGRESS = 'FULL_IN_PROGRESS',
}

export enum OrderReturnState {
    PARTIAL = 'PARTIAL',
    NONE = 'NONE',
    FULL = 'FULL',
}

export enum OrderCancellabilityState {
    ONLY_FULL = 'ONLY_FULL',
    PARTIAL = 'PARTIAL',
    NOT_CANCELABLE = 'NOT_CANCELABLE',
}

export enum ItemState {
    INITIAL = 'INITIAL',
    SHIPPED = 'SHIPPED',
    CANCELED = 'CANCELED',
    RETURNED = 'RETURNED',
    CANCELLATION_IN_PROGRESS = 'CANCELLATION_IN_PROGRESS',
    CANCELLATION_FAILED = 'CANCELLATION_FAILED',
}

export interface Money {
    amount: number;
    currency: string;
}

const PaymentMethods = [
    'CASH_ON_DELIVERY',
    'CHEQUE',
    'CREDITCARD',
    'DIRECTDEBIT',
    'EPS',
    'IDEAL',
    'INVOICE',
    'MISTERCASH',
    'PAYPAL',
    'POSTFINANCE',
    'PREPAYMENT',
    'PTF',
] as const;

export type PaymentMethod = typeof PaymentMethods[number];

export interface Links {
    next?: {
        href: string;
    };
}

export interface Item {
    name: string;
    campaign_name?: string;
    images: string[];
    delivery_date_from?: string;
    delivery_date_to?: string;
    id: string;
    is_cancellable?: boolean;
    config_sku: string;
    gross_retail_price: Money;
    item_state: ItemState;
    size: string;
}

export type CountryCode =
    | 'DE'
    | 'FR'
    | 'UK'
    | 'PL'
    | 'FI'
    | 'BE'
    | 'ES'
    | 'IT'
    | 'AT'
    | 'CH'
    | 'NL'
    | 'CZ'
    | 'DK'
    | 'SE';

export interface Address {
    country_code: CountryCode;
    zip: string;
    city: string;
    street: string;
    first_name: string;
    last_name: string;
}

export interface Order {
    order_number: string;
    date: string;
    item_count: number;
    items: Item[];
    creation_date: string;
    payment_method: PaymentMethod;
    grand_total: Money;
    gross_retail_total: Money;
    gross_shipping_total: Money;
    gross_discount_total: Money;
    total_savings: Money;
    order_state: OrderState;
    order_return_state?: OrderReturnState;
    order_cancellation_state?: OrderCancelationState;
    is_order_returnable?: boolean;
    order_cancellability_state?: OrderCancellabilityState;
    tracking_link?: string;
    delivery_address: Address;
    billing_address: Address;
    order_delivery_date_from?: string;
    order_delivery_date_to?: string;
}
